import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";
import { MailCheck, ArrowLeft, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); } catch { /* non-enumerating */ }
    setSent(true); setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
        <Link to="/login" className="flex items-center mb-10"><Logo className="text-2xl" showDot /></Link>
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <MailCheck className="w-12 h-12 text-teal-500 mx-auto mb-5" />
            <h1 className="font-serif text-3xl mb-2">Check your inbox</h1>
            <p className="text-muted-foreground text-sm mb-8">If an account exists for <strong>{email}</strong>, we've sent a link to reset your password. It expires in an hour.</p>
            <Link to="/login" className="text-primary text-sm inline-flex items-center gap-1" data-testid="forgot-back-login"><ArrowLeft className="w-4 h-4" /> Back to log in</Link>
          </div>
        ) : (
          <>
            <h1 className="font-serif text-4xl mb-2">Reset your password</h1>
            <p className="text-muted-foreground mb-8 text-sm">Enter your email and we'll send you a link to set a new one.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" className="mt-1.5 rounded-full" placeholder="you@email.com" />
              </div>
              <Button type="submit" className="w-full rounded-full" disabled={loading} data-testid="forgot-submit-btn">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
              </Button>
            </form>
            <p className="text-sm text-muted-foreground mt-6 text-center">
              Remembered it? <Link to="/login" className="text-primary" data-testid="forgot-login-link">Log in</Link>
            </p>
          </>
        )}
      </motion.div>
    </div>
  );
}
